import React, { PureComponent } from 'react';
import { Checkbox, Input } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { store } from 'redux-rest-reducer';
import styled from 'styled-components';
import moment from 'moment';

import { Text, Separator, Button, Row, Col } from '@cuemath/comps';
import { patch as editStudentDemo } from 'actions/student-demos';
import { openModal, closeModal } from 'actions/modal';

import { invalidateList as invalidateStudentDemoList } from 'actions/student-demo-list';

import { ButtonWrapper, Head, Message } from 'modules/form';

import { Block } from 'styled-icons/boxicons-regular/Block';
import { UAE_REGION_CONSTANTS } from 'constants/av-player';

import {
  PATCH_ACTION,
  MODAL_TYPE,
  STUDENT_ACTION_DATA,
  DEFAULT_CLASS_DURATION,
  demoCancellationReasons,
} from 'constants/form';
import { Dropdown } from 'semantic-ui-react';

const ButtonStyle = styled(Col)`
  margin-left: -28px;
`;

const TextStyle = styled(Text)`
  div {
    margin-left: -50px;
  }
`;

const StyedDropdown = styled.div`
  width: 160px;
`;

export const Field = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 2rem;
  justify-content: space-between;
`;

export const SingleField = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-left: 80px;
`;

export const FieldWrapper = styled.div`
  width: 80%;
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
`;

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  padding: 20px 0px 20px 50px;
`;

const BasisLabelContainer = styled(Row)`
  flex-basis: 50%;
`;

const BasisContentContainer = styled(Row)`
  flex-basis: 50%;
`;

const InputStyle = styled(Input)`
  width: 160px;
`;

const BlockIcon = styled(Block)`
  width: 20px;
  height: 20px;
  color: red;
  font-weight: bold;
`;

const WarningText = styled(Text)`
  width: 300px;
  margin-left: 5px;
  font-style: italic;
`;

const StyledButton = styled(Button)`
  cursor: ${({ disableToggle }) => (disableToggle ? 'not-allowed' : 'initial')};
`;
class UpdateDemoModal extends PureComponent {
  static defaultProps = {
    student: null,
  };

  static propTypes = {
    students: PropTypes.object,
    modalType: PropTypes.string,
    getStudentDemoData: PropTypes.func,
    actions: PropTypes.shape({
      closeModal: PropTypes.func.isRequired,
      editStudentDemo: PropTypes.func.isRequired,
    }).isRequired,
  };

  constructor(props) {
    super(props);
    const { data } = props;
    const { scheduled_start_time: scheduledStartTime, rm_call_enabled: rmCallEnabled } =
      data || {};

    const existingDate = scheduledStartTime
      ? moment(scheduledStartTime * 1000).format('YYYY-MM-DD')
      : moment().format('YYYY-MM-DD');
    const existingTime = existingDate
      ? moment(scheduledStartTime * 1000).format('HH:mm')
      : moment().format('HH:mm');

    this.state = {
      dateError: false,
      duration: null,
      error: {},
      errorText: null,
      patchDone: null,
      cancellationReason: null,
      othersCancelReason: null,
      rmCallEnabledState: rmCallEnabled,
      startDate: existingDate,
      startTime: existingTime,
      student: data,
      studentPatch: store.patch(),
    };
  }

  static getDerivedStateFromProps(props, state) {
    const { studentDemos, actions, getStudentDemoData } = props;
    let { errorText, patchDone } = state;

    const newStudentPatch = store.patch(studentDemos, state.studentPatch.id);

    if (patchDone) {
      return null;
    }

    if (newStudentPatch.resolved && newStudentPatch.resolved.isPatched) {
      errorText = null;
      patchDone = true;
      actions.closeModal();
      getStudentDemoData(true);
    } else if (newStudentPatch.resolved && newStudentPatch.resolved.isPatchingFailed) {
      errorText = store.getError(newStudentPatch.resolved)
        ? store.getError(newStudentPatch.resolved).message
        : 'Error';
      patchDone = false;
    }

    return {
      errorText,
      patchDone,
    };
  }

  onSubmit = event => {
    event.preventDefault();
    const { actions, modalType, data } = this.props;
    const {
      startDate,
      startTime,
      duration: timeDelta,
      student,
      rmCallEnabledState,
    } = this.state;
    const duration = timeDelta || DEFAULT_CLASS_DURATION;
    const {
      studentPatch: { id },
    } = this.state;
    const startDateObj = `${startDate} ${startTime}`;

    const { isPlusLead } = data;

    const newDate = moment(startDateObj).format('X');
    const endTime = moment(startDateObj)
      .add(parseInt(duration, 10), 'minutes')
      .format('X');
    let action;
    let actionData;

    if (MODAL_TYPE.TOGGLE_RM_CALL === modalType) {
      action = PATCH_ACTION.SET_RM_CALL;
      actionData = {
        rm_call_enabled: rmCallEnabledState,
      };
    } else if (MODAL_TYPE.UPDATE === modalType) {
      action = PATCH_ACTION.SET_SCHEDULE;
      actionData = {
        scheduled_start_time: newDate,
        scheduled_end_time: endTime,
        is_plus_lead: isPlusLead,
      };
    } else if (MODAL_TYPE.PAID === modalType) {
      action = PATCH_ACTION.PAID;
      actionData = {
        state: STUDENT_ACTION_DATA.PAID,
      };
    } else if (MODAL_TYPE.NOT_INTERESTED === modalType) {
      action = PATCH_ACTION.NOT_INTERESTED;
      actionData = {
        state: STUDENT_ACTION_DATA.NOT_INTERESTED,
      };
    } else if (MODAL_TYPE.DISABLE === modalType) {
      action = PATCH_ACTION.DISABLE;
      actionData = {
        state: STUDENT_ACTION_DATA.NONE,
      };
    }

    actions.editStudentDemo(id, student.id, {
      action: action,
      action_data: actionData,
    });
  };

  onCancel = event => {
    event.preventDefault();
    const { actions } = this.props;
    const { student } = this.state;

    const {
      studentPatch: { id },
    } = this.state;

    actions.editStudentDemo(id, student.id, {
      action: PATCH_ACTION.SET_SCHEDULE,
      action_data: {
        scheduled_start_time: null,
        scheduled_end_time: null,
        demo_cancellation_reason:
          this.state?.cancellationReason === 'others'
            ? this.state?.othersCancelReason
            : this.state?.cancellationReason,
      },
    });
  };

  onChange = (event, { value }) => {
    const { startDate } = this.state;

    const currentDate = moment().format('YYYY-MM-DD');
    console.log('VALUE', startDate, value, startDate < value);

    if (currentDate && value < currentDate) {
      this.setState({
        error: true,
        startDate: '',
      });
    } else {
      this.setState({
        error: false,
        startDate: value,
      });
    }
  };

  onTimeChange = (event, { value }) => {
    this.setState({
      dateError: false,
      startTime: value,
    });
  };

  onDurationChange = (event, { value }) => {
    this.setState({
      dateError: false,
      duration: value,
    });
  };

  handleRMCallCheckBox = (event, { checked }) => {
    this.setState({
      rmCallEnabledState: checked,
    });
  };

  handleDemoCancel = (e, { value }) => {
    this.setState({ cancellationReason: value });
  };

  handleOthersCancelReason = (e, { value }) => {
    this.setState({ othersCancelReason: value });
  };

  renderUpdateDemo() {
    const { errorText, startTime, startDate, dateError, error } = this.state;

    const { data } = this.props;
    const currentDate = moment().format('YYYY-MM-DD');
    const { cancellationReason } = this.state;
    const isCancellationReasonAvailable =
      (cancellationReason === 'others' && !this.state.othersCancelReason) ||
      !cancellationReason;

    return (
      <StyledForm>
        {errorText && <Message error={true}>{errorText}</Message>}
        <Head>
          <TextStyle>
            <Text size="xlarge" align="center">
              Update Demo
            </Text>
          </TextStyle>
        </Head>
        <Separator transparent height="30" />
        <FieldWrapper>
          <Field key="teachers">
            <BasisLabelContainer>
              <Text size="normal">Teacher Name</Text>
            </BasisLabelContainer>
            <BasisContentContainer>
              <Text>{data.teacher_name ? data.teacher_name : 'NA'}</Text>
            </BasisContentContainer>
          </Field>
        </FieldWrapper>
        <Separator transparent height="30" />
        <FieldWrapper>
          <Field key="teachers">
            <BasisLabelContainer>
              <Text size="normal">Student Name</Text>
            </BasisLabelContainer>
            <BasisContentContainer>
              <Text>{data.student_name ? data.student_name : 'NA'}</Text>
            </BasisContentContainer>
          </Field>
        </FieldWrapper>
        <Separator transparent height="30" />
        <FieldWrapper>
          <Field key="teachers">
            <BasisLabelContainer>
              <Text size="normal">Demo date</Text>
            </BasisLabelContainer>
            <BasisContentContainer>
              <InputStyle
                name="startDate"
                type="date"
                required={true}
                value={startDate}
                min={currentDate}
                onChange={this.onChange}
                error={error}
              />
            </BasisContentContainer>
          </Field>
        </FieldWrapper>
        <Separator transparent height="20" />
        <FieldWrapper>
          <Field key="teachers">
            <BasisLabelContainer>
              <Text size="normal">Demo time</Text>
            </BasisLabelContainer>
            <BasisContentContainer>
              <InputStyle
                name="startTime"
                type="time"
                required={true}
                value={startTime}
                onChange={this.onTimeChange}
                error={dateError}
              />
            </BasisContentContainer>
          </Field>
        </FieldWrapper>
        <Separator transparent height="20" />
        <FieldWrapper>
          <Field key="teachers">
            <BasisLabelContainer>
              <Text size="normal">Duration</Text>
            </BasisLabelContainer>
            <BasisContentContainer>
              <InputStyle
                name="duration"
                type="text"
                placeholder="Minutes"
                onChange={this.onDurationChange}
              />
            </BasisContentContainer>
          </Field>
        </FieldWrapper>
        <Separator transparent height="20" />
        <FieldWrapper>
          <Field key="teachers">
            <BasisLabelContainer>
              <Button label="Update" id="submit" onClick={this.onSubmit} />
            </BasisLabelContainer>
          </Field>
        </FieldWrapper>
        <Separator transparent height="20" />
        <Head>
          <TextStyle>
            <Text size="xlarge" align="center">
              Cancel Demo
            </Text>
          </TextStyle>
        </Head>
        <Separator transparent height="30" />
        <FieldWrapper>
          <Field key="teachers">
            <BasisLabelContainer>
              <Text size="normal">Cancel reason</Text>
            </BasisLabelContainer>
            <BasisLabelContainer>
              <StyedDropdown>
                <Dropdown
                  placeholder="Select reason"
                  fluid
                  selection
                  options={demoCancellationReasons}
                  value={cancellationReason}
                  onChange={this.handleDemoCancel}
                  upward
                />
              </StyedDropdown>
              {cancellationReason === 'others' && (
                <InputStyle
                  type="text"
                  placeholder="Other reason"
                  value={this.state.othersCancelReason}
                  onChange={this.handleOthersCancelReason}
                />
              )}
            </BasisLabelContainer>
          </Field>
        </FieldWrapper>
        <Separator transparent height="20" />
        <ButtonWrapper>
          <FieldWrapper>
            <Field key="teachers">
              <ButtonStyle>
                <Button
                  disabled={isCancellationReasonAvailable}
                  label="Cancel Demo"
                  renderAs="link"
                  onClick={this.onCancel}
                />
              </ButtonStyle>
            </Field>
          </FieldWrapper>
        </ButtonWrapper>
        <Separator transparent height="35" />
      </StyledForm>
    );
  }

  renderPaidModal() {
    const { errorText } = this.state;

    return (
      <StyledForm>
        {errorText && <Message error={true}>{errorText}</Message>}
        <Head>
          <Text size="xlarge" align="center">
            Udpdate reason
          </Text>
        </Head>
        <Separator transparent height="35" />
        <FieldWrapper>
          <Field key="teachers">
            <Text size="normal">Are you sure you want to mark student as Paid?</Text>
          </Field>
        </FieldWrapper>
        <Separator transparent height="35" />
        <ButtonWrapper>
          <FieldWrapper>
            <Field key="teachers">
              <BasisLabelContainer>
                <Button label="Update" id="submit" onClick={this.onSubmit} />
              </BasisLabelContainer>
            </Field>
          </FieldWrapper>
        </ButtonWrapper>
        <Separator transparent height="35" />
      </StyledForm>
    );
  }

  renderNotInterestedModal() {
    const { errorText } = this.state;

    return (
      <StyledForm>
        {errorText && <Message error={true}>{errorText}</Message>}
        <Head>
          <Text size="xlarge" align="center">
            Udpdate reason
          </Text>
        </Head>
        <Separator transparent height="35" />
        <FieldWrapper>
          <Field key="teachers">
            <Text size="normal">
              Are you sure you want to mark student as not interested?
            </Text>
          </Field>
        </FieldWrapper>
        <Separator transparent height="35" />
        <ButtonWrapper>
          <FieldWrapper>
            <Field key="teachers">
              <BasisLabelContainer>
                <Button label="Update" id="submit" onClick={this.onSubmit} />
              </BasisLabelContainer>
            </Field>
          </FieldWrapper>
        </ButtonWrapper>
        <Separator transparent height="35" />
      </StyledForm>
    );
  }

  renderDisableModal() {
    const { errorText } = this.state;
    const { data } = this.props;

    let { teacher_name: teacherName, student_name: studentName } = data;

    studentName = studentName
      ? studentName.charAt(0).toUpperCase() + studentName.slice(1)
      : '';

    return (
      <StyledForm>
        {errorText && <Message error={true}>{errorText}</Message>}
        <Head>
          <Text size="xlarge" align="center">
            Disable teacher
          </Text>
        </Head>
        <Separator transparent height="35" />
        <FieldWrapper>
          <Field key="teachers">
            <Text size="normal">
              Are you sure you want to disable the teacher{' '}
              <strong>{teacherName ? teacherName : 'NA'}</strong> to act on the student{' '}
              <strong>{studentName ? studentName : 'NA'}</strong> ?
            </Text>
          </Field>
        </FieldWrapper>
        <Separator transparent height="35" />
        <FieldWrapper>
          <Field key="teachers">
            <Row>
              <Text size="normal" weight="bolder">
                Note:
              </Text>
            </Row>
          </Field>
        </FieldWrapper>
        <FieldWrapper>
          <Field key="teachers">
            <Row>
              <Text>
                Confirming this will ensure that{' '}
                <strong>{studentName ? studentName : 'NA'} as a lead </strong>
                WILL BE <strong>removed </strong>from the teacher's lead management system
              </Text>
            </Row>
          </Field>
        </FieldWrapper>
        <Separator transparent height="35" />
        <ButtonWrapper>
          <FieldWrapper>
            <Field key="teachers">
              <Button label="Disable the teacher" id="submit" onClick={this.onSubmit} />
            </Field>
          </FieldWrapper>
        </ButtonWrapper>
        <Separator transparent height="35" />
      </StyledForm>
    );
  }

  renderToggleRMCall() {
    const { errorText, rmCallEnabledState } = this.state;

    const { data } = this.props;
    const { recent_schedule_teacher_classroom_media_provider: mediaServer } = data;
    const disableToggle = mediaServer === UAE_REGION_CONSTANTS.HMS ? true : false;

    return (
      <StyledForm>
        {errorText && <Message error={true}>{errorText}</Message>}
        <Head>
          <Text size="xlarge" align="center">
            Toggle RM Call
          </Text>
        </Head>
        <Separator transparent height="35" />
        {disableToggle && (
          <Row>
            <BlockIcon />
            <WarningText size="normal">
              {UAE_REGION_CONSTANTS.RM_DISABLED_TOGGLE_TEXT}
            </WarningText>
          </Row>
        )}
        {disableToggle && <Separator transparent height="20" />}
        <FieldWrapper>
          <Field key="rm">
            <BasisLabelContainer>
              <Text size="normal">RM Call</Text>
            </BasisLabelContainer>
            <BasisContentContainer>
              <Checkbox
                disabled={disableToggle}
                checked={rmCallEnabledState}
                name="is_rm_call_enabled"
                onChange={this.handleRMCallCheckBox}
                toggle
              />
            </BasisContentContainer>
          </Field>
        </FieldWrapper>
        <Separator transparent height="35" />
        <ButtonWrapper>
          <FieldWrapper>
            <SingleField key="teachers">
              <BasisLabelContainer>
                <StyledButton
                  label="Update"
                  id="submit"
                  onClick={this.onSubmit}
                  disabled={disableToggle}
                  disableToggle={disableToggle}
                />
              </BasisLabelContainer>
            </SingleField>
          </FieldWrapper>
        </ButtonWrapper>
        <Separator transparent height="35" />
      </StyledForm>
    );
  }

  renderModal() {
    const { modalType } = this.props;

    switch (modalType) {
      case MODAL_TYPE.TOGGLE_RM_CALL:
        return <div>{this.renderToggleRMCall()}</div>;
      case MODAL_TYPE.UPDATE:
        return <div>{this.renderUpdateDemo()}</div>;
      case MODAL_TYPE.PAID:
        return <div>{this.renderPaidModal()}</div>;
      case MODAL_TYPE.NOT_INTERESTED:
        return <div>{this.renderNotInterestedModal()}</div>;
      case MODAL_TYPE.DISABLE:
        return <div>{this.renderDisableModal()}</div>;
      default:
        return modalType;
    }
  }

  render() {
    return <div>{this.renderModal()}</div>;
  }
}

export default connect(
  ({ studentDemos }) => ({
    studentDemos,
  }),
  dispatch => ({
    actions: bindActionCreators(
      {
        openModal,
        editStudentDemo,
        closeModal,
        invalidateStudentDemoList,
      },
      dispatch,
    ),
  }),
)(UpdateDemoModal);
